import classNames from 'classnames'

import Dropdown from '../../00-Primitives/Inputs/Dropdown'

import style from './style.scss'

type FilterState = {
  [key: string]: string
}

export type FilterProps = {
  fieldId: 'regions' | 'subjects'
  inputId: string
  label: string
  options: Array<{ label: string; value: string }>
  placeholder?: string
}

export type Props = {
  className?: string
  filters: Array<FilterProps>
  handleFilterChange: (id: 'regions' | 'subjects', val: string) => void
  state: FilterState
}

Filters.defaultProps = {
  className: '',
}

function Filters(props: Props) {
  const { className, filters, handleFilterChange, state } = props

  return (
    <div className={classNames(style.wrapper, className)}>
      {filters.map(({ fieldId, inputId, label, options, placeholder }) =>
        options.length > 1 ? (
          <Dropdown
            key={inputId}
            className={style.dropdown}
            handleOptionChange={(val) => handleFilterChange(fieldId, val)}
            inputId={inputId}
            label={label}
            options={options}
            placeholder={placeholder}
            selectedOption={state[fieldId]}
          />
        ) : null,
      )}
    </div>
  )
}

export default Filters
